<template>
  <div class="container p-mt-6">
    <h2 class="p-text-center p-mb-5">Admin Uso</h2>
    <div class="p-grid p-justify-center">
      
      <div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Uso y sin Uso "
          icon="pi pi-question-circle"
          class="p-button-raised p-button-success w-full"
          @click="ir('uso-alumnos')"
        />
      </div>


      <div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Uso por Curso"
          icon="pi pi-chart-bar"
          class="p-button-raised p-button-success w-full"
          @click="ir('uso-curso')"
        />
      </div>

      <div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Interaccion Practicas por curso"
          icon="pi pi-chart-bar"
          class="p-button-raised p-button-success w-full"
          @click="ir('uso-practica')"
        />
        <div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Interaccion Test por curso"
          icon="pi pi-chart-bar"
          class="p-button-raised p-button-success w-full"
          @click="ir('uso-test')"
        />
      </div>



        <ButtonPrime
          label="Interaccion Practicas Multiple Asignatura"
          icon="pi pi-chart-bar"
          class="p-button-raised p-button-success w-full"
          @click="ir('uso-practica-multiple')"
        />

        <ButtonPrime
          label="Cumplimiento Practicas"
          icon="pi pi-chart-bar"
          class="p-button-raised p-button-success w-full"
          @click="ir('cumplimiento-practicas')"
        />

        <ButtonPrime
          label="Interaccion Test Multiple asignatura"
          icon="pi pi-chart-bar"
          class="p-button-raised p-button-success w-full"
          @click="ir('informe-interaccion-test')"
        />

        <ButtonPrime
          label="Cumplimiento Test"
          icon="pi pi-chart-bar"
          class="p-button-raised p-button-success w-full"
          @click="ir('informe-cumplimiento-test')"
        />

        <ButtonPrime
          label="Interaccion Videos Visualizacion"
          icon="pi pi-chart-bar"
          class="p-button-raised p-button-success w-full"
          @click="ir('informe-visualizacion-video')"
        />

        <ButtonPrime
          label="Interaccion Juegos Multiple asignatura"
          icon="pi pi-chart-bar"
          class="p-button-raised p-button-success w-full"
          @click="ir('informe-interaccion-juego')"
        />

        <ButtonPrime
          label="Cumplimiento Juegos"
          icon="pi pi-chart-bar"
          class="p-button-raised p-button-success w-full"
          @click="ir('informe-cumplimiento-juego')"
        />


         <ButtonPrime
          label="Informe Iteraccion Total"
          icon="pi pi-chart-bar"
          class="p-button-raised p-button-success w-full"
          @click="ir('informe-interaccion-total')"
        />


      </div>

      
      

      <!--div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Interaccion Juego"
          icon="pi pi-chart-bar"
          class="p-button-raised p-button-success w-full"
          @click="ir('uso-juego')"
        />
      </div-->

    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
  name: 'AdminUso',
  setup() {
    const router = useRouter();

     const ir = (r) => {
      router.push({
        name: r,
      });
    };

    return {
      ir,
    };
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.w-full {
  width: 100%;
}

.p-button-raised {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s;
}

.p-button-raised:hover {
  transform: translateY(-2px);
}

.p-text-center {
  color: #333;
  font-weight: 600;
}

@media (max-width: 768px) {
  .p-grid {
    flex-direction: column;
    align-items: center;
  }
}
</style>